import { http, HttpResponse } from 'msw';

import contractResponse from './contract_response.json';
import { apiEndpoints } from '../../lib';

// Synthetic sample contract payload — mocks must never contain real customer data.
export const mockContractResponse = contractResponse;

export const contractHandlers = {
  success: http.get(
    apiEndpoints.contract(),
    () => HttpResponse.json({ data: mockContractResponse }, { status: 200 }),
  ),
};
